import { lireZonage } from './db'
import { trierSecteurs, ZONAGE_REPLI } from '../domaine/secteurs'
import type { SecteurZonage } from '../domaine/types'

let cache: SecteurZonage[] | null = null

/**
 * Zonage utilisable maintenant.
 *
 * Priorité au zonage reçu du serveur et conservé localement. S'il est vide
 * (appareil qui n'a jamais joint le serveur), on retombe sur la liste
 * embarquée : une patrouille ne doit jamais être empêchée d'enregistrer une
 * ponte parce qu'un appel réseau a échoué.
 */
export async function zonage(): Promise<SecteurZonage[]> {
  if (cache) return cache
  const local = await lireZonage()
  cache = trierSecteurs(local.length > 0 ? local : ZONAGE_REPLI)
  return cache
}

/** À appeler après un rafraîchissement du zonage. */
export function viderCacheZonage(): void {
  cache = null
}
